import fetch from 'actions/lib/fetch';

const actionPrefix = 'chat/bot/';

export const CHAT_BOT_TYPE = {
  mbfDirectLine: 'chat-bot-type/microsoft-bot-framework/direct-line',
};

export const CHAT_BOT_TYPE_MAP = new Map([
  [1, CHAT_BOT_TYPE.mbfDirectLine],
]);

export const START = `${actionPrefix}start`;
export const START_REQUEST = `${actionPrefix}start/request`;
export const START_FAIL = `${actionPrefix}start/fail`;
export const start = configuration => dispatch => {
  dispatch({ type: START_REQUEST });

  return fetch(`bot`, { method: 'GET'})
    .then(({ session: { conversation, yourId }, client, queueProperties, caseComments }) => dispatch({
      type: START, conversation, userId: yourId, client, queueProperties, caseComments
    }))
    .catch(error => dispatch({ type: START_FAIL, error }));
};

export const STATUS_CHANGED = `${actionPrefix}status-changed`;
export const statusChanged = status => ({ type: STATUS_CHANGED, status });

export const ACTIVITY_PUBLISHED = `${actionPrefix}activity-published`;
export const ACTIVITY_RECEIVED = `${actionPrefix}activity-received`;
export const activityPublished = id => ({ type: ACTIVITY_PUBLISHED, id });
export const activityReceived = activity => ({ type: ACTIVITY_RECEIVED, activity });

export const END = `${actionPrefix}end`;
export const end = () => ({ type: END });

export const FAIL = `${actionPrefix}error`;
export const fail = error => ({ type: FAIL, error });



// WEBPACK FOOTER //
// ./actions/chat/bot.js